import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessListEmbedRoute: InvariantJiraRoute = {
	name: 'classic-business-list-embed',
	path: '/jira/core/projects/:projectKey/list/embed',
	exact: true,
};
